<template>
  <div class="common_module page-panel">
    <div class="page-panel__header">
      <div class="page-panel-header__control">
        <el-button class="page-panel-header-control-button" size="mini" type="primary"
          @click="dialogVisable=true,allianceDialogTitle='新增联盟信息'">新增
        </el-button>
      </div>
      <div class="page-panel-header__title">联盟管理</div>
    </div>
    <div class="page-panel__body">
      <el-form class="page-panel-search-form" :inline="true">
        <div class="page-panel-search-bread">
          <span v-for="item in commonJSON.vipType.options" :key="item.value"
            :class="{isactive:item.value==searchModel.orgType}"
            @click="getAllianceListByTypeId(item.value)">{{item.label}}</span>
        </div>
      </el-form>
      <el-table border stripe :data="allianceList">
        <el-table-column label="序号" type="index" width="60" align="center">
        </el-table-column>
        <el-table-column label="单位编号" prop="orgId" align="center" width="120">
        </el-table-column>
        <el-table-column label="单位名称" align="center" prop="orgName">
        </el-table-column>
        <el-table-column label="单位类别" align="center" prop="orgTypeName" width="120">
        </el-table-column>
        <el-table-column label="图片地址" align="center" width="110">
          <template slot-scope="scope">
            <img :src="scope.row.orgImg?scope.row.orgImg:'/static/img/common/zwtp.png'" class="table_image"
              onerror="this.src='/static/img/common/zwtp.png'">
          </template>
        </el-table-column>
        <el-table-column label="vip到期时间" align="center" width="150">
          <template slot-scope="scope">
            {{scope.row.orgVipTime?scope.row.orgVipTime:'-'}}
          </template>
        </el-table-column>
        <el-table-column label="vip级别" align="center" width="120">
          <template slot-scope="scope">
            {{scope.row.orgVipType?scope.row.orgVipType:'-'}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="editAlliance(scope.row)">编辑</el-button>
            <el-button type="text" @click="deleteAlliance(scope.row.orgId)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page-panel__footer">
        <el-pagination :current-page.sync='searchModel.pageNo' :page-size='searchModel.pageSize'
          layout='prev, pager, next, jumper' :total='total'
          @current-change='getAllianceListByTypeId(searchModel.orgType)'>
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="allianceDialogTitle" :visible.sync="dialogVisable" width="55%">
      <el-form>
        <table class="form-editor">
          <tr>
            <th><span class="required_column">*</span>公司(联盟)名称</th>
            <td>
              <el-input placeholder="请输入标题名称" v-model="allianceParam.orgName"></el-input>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>公司类别</th>
            <td>
              <el-select v-model="allianceParam.orgType" placeholder="请选择公司类别">
                <el-option v-for="item in commonJSON.vipType.options" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </td>
          </tr>
          <tr>
            <th>图片地址</th>
            <td>
              <el-upload class="avatar-uploader" action="/file/upload" :show-file-list="false"
                :on-success="uploadSuccess">
                <img v-if="imageUrl" :src="imageUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </td>
          </tr>
          <tr>
            <th><span class="required_column">*</span>公司(联盟)介绍</th>
            <td>
              <ueditor :config="editorConfig" v-model="allianceParam.orgText"></ueditor>
            </td>
          </tr>
        </table>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisable= false">取消</el-button>
        <el-button type="primary" @click="addAlliance">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import * as allianceApi from '@/api/alliance';
const commonJSON = require('@/common/Json/index');
export default {
  data() {
    return {
      commonJSON,
      allianceDialogTitle: '新增联盟成员信息',
      imageUrl: '',
      allianceParam: {},
      dialogVisable: false,
      selectValue: 1,
      total: 0,
      allianceList: [],
      searchModel: {
        pageNo: 1,
        pageSize: 10,
        orgType: 1
      },
      editorConfig: {
        initialFrameWidth: '100%',
        initialFrameHeight: 300,
        zIndex: 0
      }
    };
  },
  methods: {
    checkInfo(info) {
      if (!info.orgName) {
        this.$notify({
          title: '警告',
          message: '请输入公司(联盟)名称',
          type: 'warning'
        });
        return false;
      } else if (info.orgName.length > 70) {
        this.$notify({
          title: '警告',
          message: '名称字数不能超过70',
          type: 'warning'
        });
        return false;
      } else if (!info.orgType) {
        this.$notify({
          title: '警告',
          message: '请选择公司类别',
          type: 'warning'
        });
        return false;
      } else if (!info.orgText) {
        this.$notify({
          title: '警告',
          message: '请输入公司(联盟)介绍',
          type: 'warning'
        });
        return false;
      } else {
        return true;
      }
    },
    uploadSuccess(res, file, fileList) {
      this.allianceParam.orgImg = res.url;
      this.imageUrl = res.url;
    },
    editAlliance(row) {
      this.allianceDialogTitle = '编辑联盟信息';
      this.allianceParam = JSON.parse(JSON.stringify(row));
      this.dialogVisable = true;
    },
    deleteAlliance(id) {
      this.$confirm('是否删除该模块信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          allianceApi.deleteAlliance({ orgId: id }).then(res => {
            this.getAllianceListByTypeId(this.searchModel.orgType);
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    },
    addAlliance() {
      if (this.checkInfo(this.allianceParam)) {
        if (this.allianceParam.orgId) {
          allianceApi.updateAlliance(this.allianceParam).then(res => {
            this.init();
          });
        } else {
          allianceApi.addAlliance(this.allianceParam).then(res => {
            this.init();
          });
        }
      }
    },
    init() {
      this.getAllianceListByTypeId(this.allianceParam.orgType);
      this.allianceParam = {};
      this.dialogVisable = false;
    },
    getAllianceListByTypeId(val) {
      if (val) {
        this.searchModel.orgType = val;
      }
      allianceApi
        .getAllianceListByTypeId({
          ...this.searchModel
        })
        .then(res => {
          this.allianceList = res.data.records;
          this.total = res.data.total;
        });
    }
  },
  created() {
    this.getAllianceListByTypeId(1);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/adminPage/allianceManagement/index.vue